import { useEffect, useState } from 'react';
import Card from '../../components/Card/Card';
import { useParams, useNavigate } from 'react-router-dom';
import { enqueueSnackbar } from 'notistack';
import { createStakeholderRequestType, updateStakeholderRequestType, getStakeholderRequestTypeById } from '../../services/StakeholderRequestTypeService';
import StakeholderRequestTypeForm from './StakeholderRequestTypeForm';

const StakeholderRequestTypeManage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [name, setName] = useState('');
  const [subTypes, setSubTypes] = useState([{ name: '' }]);
  const [loader, setLoader] = useState(false);


  useEffect(() => {
    if (id) {
      fetchStakeholderRequestTypeByID(id);
    }
  }, [id]);

  const fetchStakeholderRequestTypeByID = async (id) => {
    try {
      setLoader(true);
      const response = await getStakeholderRequestTypeById(id);
      if (response.status === 200) {
        const { name, sub_types } = response.data.data;
        setName(name);
        setSubTypes(sub_types);
        if (sub_types.length === 0) {
          setSubTypes([{ name: '' }]);
        }
      }
    } catch (error) {
      // Handle error
      return error;
    }
    finally {
      setLoader(false);
    }
  };

  const handleChange = (event) => {
    setName(event.target.value);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!name) {
      let msg = 'Please enter name';
      enqueueSnackbar(msg, { variant: 'error' });
      return;
    }

    try {
      const requestData = {
        name,
        sub_types: subTypes
      };

      setLoader(true);
      let response = id ? await updateStakeholderRequestType(id, requestData) :
        await createStakeholderRequestType(requestData);

      if (response.status === 200) {
        let msg = response.data.message.success;
        enqueueSnackbar(msg, { variant: 'success' });
        navigate('/stakeholder-request-type/list');
      }
    } catch (error) {
      return error;
    }
    finally {
      setLoader(false);
    }
  };

  const goBack = () => {
    navigate('/stakeholder-request-type/list');
  };

  const subTypeChangeHandler = (event) => {
    const updatedSubTypes = subTypes.map((subType, index) => {
      if (index === parseInt(event.target.name.split('_')[1])) {
        return { ...subType, name: event.target.value };
      }
      return subType;
    });
    setSubTypes(updatedSubTypes);
  };

  const addRowHandler = () => {
    setSubTypes(prevSubTypes => [...prevSubTypes, { name: '' }]);
  };

  const removeRowHandler = (record) => {
    setSubTypes(prevSubTypes => prevSubTypes.filter(r => r !== record));
  };

  return (
    <Card
      componentName={id ? "Update Stakeholder Request Type" : "Add Stakeholder Request Type"}
      back={goBack}>
      <StakeholderRequestTypeForm
        name={name}
        subTypes={subTypes}
        loader={loader}
        addRowHandler={addRowHandler}
        removeRowHandler={removeRowHandler}
        onSubTypeChangeHandler={subTypeChangeHandler}
        onChange={handleChange}
        onSubmit={handleSubmit}
      />
    </Card>
  );
}
export default StakeholderRequestTypeManage;
